import { useState } from 'react';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import SortButtons from '../../../../../components/SortButtons';
import PropTypes from 'prop-types';
import { ResourceUtils } from '../../../../assignments/components/questionDetailComponents/ResourceUtils';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../../../../features/authentication/authSlice';
import { DateFormatter } from '../../../../../utils/DateFormatter';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const IncompleteSessionsTable = ({
  data,
  setData,
  isLoading
}) => {
  const [sortId, setSortId] = useState('studentName');
  const [isAscending, setIsAscending] = useState(true);
  const ferpaEnabled = useSelector(selectFerpaState);

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);

    let sortedStudents = ResourceUtils.customSort(data, currentSortId, sortAsc);
    setData(sortedStudents);
    setIsAscending(sortAsc);
  };

  return (
    <table className='table reportTable'>
      {data?.length > 0 && !isLoading ? (
        <>
          <thead className='thead-light align-middle'>
            <tr>
              <th className='fw-medium cursor-pointer text-center' onClick={() => handleSort('studentName')}>
                Student
                <SortButtons
                  selectedSortId={sortId}
                  elementSortId="studentName"
                  isAscending={isAscending}
                />
              </th>
              <th className='fw-medium cursor-pointer text-center w-30' onClick={() => handleSort('description')}>
                Description
                <SortButtons
                  selectedSortId={sortId}
                  elementSortId="description"
                  isAscending={isAscending}
                />
              </th>
              <th className='fw-medium cursor-pointer text-center' onClick={() => handleSort('date')}>
                Date Created
                <SortButtons
                  selectedSortId={sortId}
                  elementSortId="date"
                  isAscending={isAscending}
                />
              </th>
              <th className='fw-medium cursor-pointer text-center'>
                Course
              </th>
              <th className='fw-medium cursor-pointer text-center'>
                Class
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.id || index}>
                <td className='text-center'><p className='fw-500'>{ferpaEnabled ? item.studentName : 'name hidden'}</p></td>
                <td className='text-center'>{item.description}</td>
                <td className='text-center'>{DateFormatter.toLongDateTime(item.date, false, false)}</td>
                <td className='text-center'>{item.courses?.name}</td>
                <td className='text-center'>
                  {item.classes?.length === 1 ? (
                    item.classes[0]?.name
                  ) : (
                    <OverlayTrigger
                      placement='left'
                      overlay={
                        <Tooltip className='initial-assignment-tooltip'>
                          {item.classes?.map(c => c.name).join(', ')}
                        </Tooltip>
                      }
                    >
                      <span className='cursor-pointer text-decoration-underline text-castleOrange'>
                        Classes ({item.classes?.length})
                      </span>
                    </OverlayTrigger>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </>
      ) : isLoading ? (
        <TableSkeleton colCount={5} rowCount={6} />
      ) : (
        <p className='text-danger'>No Incomplete Self Study Record Found.</p>
      )}
    </table>
  );
};

IncompleteSessionsTable.propTypes = {
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default IncompleteSessionsTable;